import { gql } from "apollo-boost";

export const INVESTOR = gql`
query investor {
	investor {
		__typename
		... on  InvestorTypeResult{
			investor {
				__typename
				... on Investor {
					investorId
					broker {
						brokerID
						name
						exchange
					}
					fullName
					phoneNo
					isApproved
					createdAt
					updatedAt
					hasPassword
				}
				... on SettradeInvestor {
					investorId
					 broker {
						brokerID
						name
						exchange
					} 
					brokerUsername
					fullName
					phoneNo
					isApproved
					createdAt
					updatedAt
					hasPassword
				}
				... on BitkubInvestor {
					investorId
					broker {
						brokerID
						name
						exchange
					}
					fullName
					phoneNo
					isApproved
					apiKey
					createdAt
					updatedAt
					hasPassword
				}
			}
		}
		... on Error {
			code
			message
		}
	}
}
`;

//investors ...
export const INVESTORS = gql`
	query investors {
		investors {
			__typename
			... on Investors {
				investors {
					investorID
					broker {
						brokerID
						name
					}
					brokerUserID
					brokerUserType
					brokerUsername
					fullName
					isCreatedByAdmin
					createdAt
					updatedAt
					investorAccounts {
						investorAccountID
						accountNo
						accountType
						subscription {
							subscriptionID
							investorAccountID
							unsubscribedAt
							placeOrderMode
							placeOrderBuySlip
							placeOrderSellSlip
							orderExpiryDay
							signalTriggerParam
							rebalanceParam
							pctFlatCommission
							pctProfitSharing
							createdAt
							updatedAt
							modelInfo {
								modelID
								name
								modelType
								modeler {
									adminID
									email
									fullName
									originalFullName
									isEmailVerified
									createdAt
									updatedAt
									avatarURL
									broker {
										brokerID
										name
									}
									role
								}
								universe
								minPortValue
								pctFlatCommission
								pctProfitSharing
								shortDesc
								longDesc
								videoURL
								svgReturnUrl
								signalType
								signalTriggerType
								signalTriggerParam
								rebalanceType
								rebalanceParam
								maxPositionType
								maxPositionParam
								maxSectorType
								maxSectorParam
								minBuyType
								minBuyParam
								minSellType
								minSellParam
								takeProfitType
								takeProfitParam
								stopLossType
								stopLossParam
								trailingStopType
								trailingStopParam
								timeStopType
								timeStopParam
								createdAt
								updatedAt
								isLaunched
								forInvestor
								forAdminInvestor
								orderExpiredDays
								isBacktesting
								backtestMessage
							}
						}
					}
				}
			}
			... on Error {
				code
				message
			}
		}
	}
`;
